"use strict";
/*
 * Created on 03 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersWeekReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceStickersWeekReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for price stickers report - one work week by days
   *
   * @param priceListTypeId id of a type of price list the counted prices are from
   * @param priceCodeId id of a price code the counted prices are assigned to
   * @param mondayRepricingCount a number of new product prices on monday this week
   * @param tuesdayRepricingCount a number of new product prices on tuesday this week
   * @param wednesdayRepricingCount a number of new product prices on wednesday this week
   * @param thursdayRepricingCount a number of new product prices on thursday this week
   * @param fridayRepricingCount a number of new product prices on friday this week
   */
  function PriceStickersWeekReportDTO(priceListTypeId, priceCodeId, mondayRepricingCount, tuesdayRepricingCount, wednesdayRepricingCount, thursdayRepricingCount, fridayRepricingCount) {
    var _this;

    _classCallCheck(this, PriceStickersWeekReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersWeekReportDTO).call(this));
    _this.priceListTypeId = priceListTypeId;
    _this.priceCodeId = priceCodeId;
    _this.mondayRepricingCount = mondayRepricingCount;
    _this.tuesdayRepricingCount = tuesdayRepricingCount;
    _this.wednesdayRepricingCount = wednesdayRepricingCount;
    _this.thursdayRepricingCount = thursdayRepricingCount;
    _this.fridayRepricingCount = fridayRepricingCount;
    return _this;
  }

  return PriceStickersWeekReportDTO;
}(DomainObject_1.DomainObject);

exports.PriceStickersWeekReportDTO = PriceStickersWeekReportDTO;

PriceStickersWeekReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceStickersWeekReportDTO.name);
  return {
    priceListTypeId: builder.str('priceListTypeId'),
    priceCodeId: builder.opt(builder.str('priceCodeId')),
    mondayRepricingCount: builder.num('mondayRepricingCount'),
    tuesdayRepricingCount: builder.num('tuesdayRepricingCount'),
    wednesdayRepricingCount: builder.num('wednesdayRepricingCount'),
    thursdayRepricingCount: builder.num('thursdayRepricingCount'),
    fridayRepricingCount: builder.num('fridayRepricingCount')
  };
}();